import React from 'react';
import styles from '../../styles/ReporteNuevosIngresosStyles/ReporteNuevosIngresos.module.css';
import { getTurnoLabel } from '../../constants/turnos';

function formatFecha(value) {
  if (!value) return '';
  const s = String(value);
  if (s.length >= 10) return s.slice(0, 10);
  return s;
}

/**
 * Tabla del reporte con paginación SERVIDOR (page_size=10).
 */
function TablaReporte({
  resultados = [],
  contexto = {},
  page = 1,
  pageSize = 10,
  total = 0,
  totalPages = 1,
  onPageChange,
}) {
  const fromRow = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const toRow = Math.min(page * pageSize, total);

  const goTo = (p) => {
    if (typeof onPageChange === 'function') {
      onPageChange(Math.max(1, Math.min(totalPages, p)));
    }
  };

  return (
    <>
      <div className={styles.reportHeader}>
        <h2 className={styles.reportTitle}>REPORTE ESTUDIANTES NUEVO INGRESO</h2>
      </div>

      <div className={styles.reportMeta}>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Ciclo:</span>
          <span>{contexto.ciclo || '—'}</span>
        </div>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Campus:</span>
          <span>{contexto.campus || 'Todos'}</span>
        </div>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Sección:</span>
          <span>{contexto.seccion || 'Todas'}</span>
        </div>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Programa:</span>
          <span>{contexto.programa || 'Todos'}</span>
        </div>
        <div className={styles.reportMetaItem}>
          <span className={styles.reportMetaLabel}>Total:</span>
          <span>{total}</span>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.reportTable}>
          <thead>
            <tr>
              <th className={styles.cellCenter}>#</th>
              <th>MATRICULA</th>
              <th>CICLO ESCOLAR DE</th>
              <th>SECCIÓN</th>
              <th>PROGRAMA ACADÉMICO</th>
              <th>TURNO</th>
              <th>NOMBRE COMPLETO</th>
              <th>CORREO PERSONAL</th>
              <th>TELÉFONO</th>
              <th>CELULAR</th>
              <th>CORREO INSTITUCIONAL</th>
              <th>FECHA DE NACIMIENTO</th>
              <th className={styles.cellCenter}>EDAD</th>
              <th>GÉNERO</th>
              <th>LUGAR DE NACIMIENTO</th>
              <th>CURP</th>
              <th>NACIONALIDAD</th>
              <th>FECHA DE REGISTRO</th>
              <th>ESCUELA DE PROCEDENCIA</th>
              <th>NOMBRE DE RESPONSABLE DE CAPTURA</th>
              <th>ESTATUS</th>
              <th>ESTADO CIVIL</th>
              <th>PADRE</th>
              <th>OCUPACIÓN DEL PADRE</th>
              <th>MADRE</th>
              <th>OCUPACIÓN DE LA MADRE</th>
              <th>DOMICILIO</th>
            </tr>
          </thead>
          <tbody>
            {resultados.length === 0 ? (
              <tr>
                <td colSpan={27} className={styles.cellCenter} style={{ padding: '20px', color: '#999' }}>
                  No hay estudiantes para los filtros aplicados.
                </td>
              </tr>
            ) : (
              resultados.map((r, idx) => (
                <tr key={`${r.id_estudiante || r.matricula}-${idx}`}>
                  <td className={styles.cellCenter}>{r.numero ?? ((page - 1) * pageSize + idx + 1)}</td>
                  <td>{r.matricula || ''}</td>
                  <td>{r.ciclo_escolar || ''}</td>
                  <td>{r.seccion || ''}</td>
                  <td>{r.programa || ''}</td>
                  <td>{getTurnoLabel(r.turno) || ''}</td>
                  <td>{r.nombre_completo || ''}</td>
                  <td>{r.correo_personal || ''}</td>
                  <td>{r.telefono || ''}</td>
                  <td>{r.celular || ''}</td>
                  <td>{r.correo_institucional || ''}</td>
                  <td>{formatFecha(r.fecha_nacimiento)}</td>
                  <td className={styles.cellCenter}>{r.edad ?? ''}</td>
                  <td>{r.genero || ''}</td>
                  <td>{r.lugar_nacimiento || ''}</td>
                  <td>{r.curp || ''}</td>
                  <td>{r.nacionalidad || ''}</td>
                  <td>{formatFecha(r.fecha_registro)}</td>
                  <td>{r.escuela_procedencia || ''}</td>
                  <td>{r.responsable_captura || ''}</td>
                  <td>{r.estatus || ''}</td>
                  <td>{r.estado_civil || ''}</td>
                  <td>{r.padre || ''}</td>
                  <td>{r.ocupacion_padre || ''}</td>
                  <td>{r.madre || ''}</td>
                  <td>{r.ocupacion_madre || ''}</td>
                  <td>{r.domicilio || ''}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {total > 0 && (
        <div className={styles.pagination}>
          <span className={styles.pageInfo}>
            Mostrando {fromRow}–{toRow} de {total}
          </span>
          <div className={styles.pageButtons}>
            <button
              type="button"
              className={styles.pageButton}
              onClick={() => goTo(page - 1)}
              disabled={page <= 1}
            >
              « Anterior
            </button>
            <span className={styles.pageInfo}>Página {page} de {totalPages}</span>
            <button
              type="button"
              className={styles.pageButton}
              onClick={() => goTo(page + 1)}
              disabled={page >= totalPages}
            >
              Siguiente »
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default TablaReporte;
